<template>
  <div :class="['ai-bubble-row', from]">
    <div v-if="from === 'nixia'" class="ai-avatar nixia-avatar">
      <i class="fa-duotone fa-solid fa-microchip-ai"></i>
    </div>

    <div class="ai-bubble" v-html="text"></div>

    <div v-if="from === 'user'" class="ai-avatar user-avatar">
      <i class="fa-solid fa-user"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "AiMessageBubble",

  props: {
    text: {
      type: String,
      required: true,
    },
    from: {
      type: String,
      required: true,
      validator: (v) => ["user", "nixia"].includes(v),
    },
  },
};
</script>

<style scoped>
.ai-bubble-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.ai-bubble-row.user {
  flex-direction: row-reverse;
}

.ai-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  flex-shrink: 0;
}

.nixia-avatar {
  background: #577696;
  color: white;
}

.user-avatar {
  background: #64748b;
  color: white;
}

.ai-bubble {
  max-width: 72%;
  padding: 12px 16px;
  border-radius: 14px;
  font-size: 14.5px;
  line-height: 1.6;
}

.nixia .ai-bubble {
  background: #f1f5f9;
  color: #1e293b;
  border-bottom-left-radius: 4px;
}

.user .ai-bubble {
  background: #1e293b;
  color: white;
  border-bottom-right-radius: 4px;
}

.dark-theme .nixia .ai-bubble {
  background: #2d3748;
  color: #e2e8f0;
}

.dark-theme .user .ai-bubble {
  background: #3b82f6;
}
</style>
